export default __webpack_public_path__ + "static/media/hhshare.d3eff22e.jpg";